import React from 'react';
import SiteHeader from './../../../components/SiteHeader';

const UserHeader = props => {
    
    const centerContent = (
        <div className="w-full">
          
        </div>
    );

    return <SiteHeader centerContent={centerContent} />;
}

export default UserHeader
